module.exports = __webpack_public_path__ + "static/r.13d1ed52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/r.jpg
// module id = 605
// module chunks = 114276838955818